import React from 'react';
import './index.css';
import App from './App';
import {Provider} from "react-redux";
import {persist, store} from "./redux/store/index.store";

import {BrowserRouter} from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import 'react-slideshow-image/dist/styles.css';
import {PersistGate} from 'redux-persist/integration/react'
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import LocationChangeMonitor from "./hoc/locationChangeMonitor/LocationChangeMonitor";
import {scrollToTop} from "./helper";
import {createRoot} from "react-dom/client";
import './i18n';
import ThemeSelector from "./hoc/themeSelector/ThemeSelector";
import {AddToHomeScreen} from "react-pwa-add-to-homescreen";


let elm = document.getElementById('root');
elm.setAttribute("style", 'min-height:100vh; display:flex; flex-direction: column;');
const root = createRoot(elm);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ThemeSelector>
                {/*<LocationChangeMonitor onChange={() => scrollToTop()}>*/}
                <LocationChangeMonitor>
                    {/*<OfflineDetector>*/}
                        <PersistGate loading={<>please wait...</>} persistor={persist}>
                            <App/>
                            <AddToHomeScreen
                                delayNotify={1000}    // نمایش بعد از 1 ثانیه
                                skipFirstVisit={false} // برای اولین بازدید هم نمایش می‌ده
                                icon="/assets/icons/icon-192x192.png"
                                className="a2hs-banner"
                                cookie={{
                                    name: 'customer-app',
                                    expireDays: 7,       // دوباره بعد از ۷ روز نمایش داده میشه
                                }}
                                translate={{
                                    headline: 'نصب اپلیکیشن ما',
                                    bottomline: 'برای داشتن تجربه بهتر، روی نصب کلیک کنید',
                                    safariTapShare: 'ابتدا روی اشتراک (Share) بزنید',
                                    safariAddHomeScreen: 'گزینه "Add to Home Screen" را انتخاب کنید',
                                    chromiumAddHomeScreen: 'از منوی مرورگر گزینه "Add to Home Screen" را انتخاب کنید',
                                    chromiumInstall: 'آیکن اپ روی صفحه اضافه خواهد شد',
                                    buttonInstall: 'نصب کن',
                                }}
                                styles={{
                                    banner: {
                                        backgroundColor: '#fff',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        padding: '12px',
                                    },
                                    buttonInstall: {
                                        backgroundColor: '#1976d2',
                                        color: '#fff',
                                        marginLeft: '8px',
                                    }
                                }}
                                // onAddToHomeClick={() => console.log("کاربر روی نصب کلیک کرد")}
                                // onClose={() => console.log("کاربر بنر رو بست")}
                            />
                        </PersistGate>
                    {/*</OfflineDetector>*/}
                </LocationChangeMonitor>
            </ThemeSelector>
        </BrowserRouter>

    </Provider>
);

// serviceWorkerRegistration.register({
//     onUpdate: (registration) => {
//         if (window.confirm("نسخه جدید اپلیکیشن منتشر شده. برای استفاده از آن، صفحه را رفرش کنید؟")) {
//             if (registration && registration.waiting) {
//                 registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//                 window.location.reload();
//             }
//         }
//     },
// });